<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import axios from "axios";
import http from "./utils/http";
import QRCode from "qrcode";
import { mapActions } from "vuex";
import { MSG } from "./utils/utils";
export default {
  name: "App",
};
</script>

<style lang="scss">
html,
body {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 !important;
  min-height: 600px;
  min-width: 1200px;
}
body,
dd,
dl,
dt,
h2,
h3,
h4,
h6,
li,
ol,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
  -webkit-text-size-adjust: none;
}
body {
  background-color: #eff3f6;
  overflow-x: hidden;
}
img {
  border: 0;
}
i,
h2,
h3,
h4,
h6 {
  font-style: normal;
}
a {
  cursor: pointer;
  text-decoration: none;
  color: #666;
}
// *,
// *:before,
// *:after {
//   -webkit-box-sizing: border-box;
//   -moz-box-sizing: border-box;
//   box-sizing: border-box;
//   margin: 0;
//   padding: 0;
// }
:focus {
  outline: none;
}
:visited {
  color: #999;
}
::-webkit-scrollbar {
  width: 3px;
  height: 6px;
}
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 6px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  -webkit-border-radius: 6px;
  background-color: #666;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  -webkit-border-radius: 6px;
  background-color: #666;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接:";
}
.ql-snow .ql-tooltip::before {
  content: "当前地址:";
}
.ql-snow .ql-tooltip a.ql-action::after {
  content: "编辑";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "确定";
  padding-right: 0px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: "删除";
}
.clear-fix {
  zoom: 1;
}
.clear-fix:after {
  display: block;
  clear: both;
  content: "";
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}

#app {
  width: 100%;
  height: 100%;
}

.el-select-dropdown {
  max-width: 540px;
}
.wj-bg-qrcode {
  background-image: url("./assets/qr-bg.png");
  background-size: contain;
  background-color: transparent;
  width: 120px;
  height: 165px;
  position: fixed;
  z-index: 1000;
  right: 15px;
  bottom: 30px;
  border-radius: 3px;
  .wj-qrcode {
    background-image: url("./assets/wx-qrcode.jpeg");
    background-size: contain;
    width: 110px;
    height: 110px;
    margin: 5px 5px 0 5px;
  }
  .wj-message {
    color: #fff;
    text-align: center;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 13px;
  }
}
.fixed-btn {
  position: fixed;
  right: 20px;
  bottom: 40px;
  height: 40px;
  border: 1px solid #eee;
  background-color: white;
  font-size: 24px;
  z-index: 1040;
  -webkit-backface-visibility: hidden;
  .fa-qrcode {
    background-image: url("./assets/qrcode-logo.png");
    background-size: contain;
    width: 38px;
    height: 38px;
  }
}
.guide-page {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  .guide-pic {
    background-image: url("./assets/pc_guide.png");
    width: 540px;
    height: 375px;
    background-size: cover;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  .confirm-btn {
    background: #ff552d;
    border-radius: 2px;
    width: 200px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% + 250px);
    text-align: center;
  }
}
#pop_body {
  z-index: 9998 !important;
}
.column-flex {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue